import { Button } from "@mui/material"

interface Props {
  label: string,
  callback: any,
  direction: number
}

const PageButton = ({ label, callback, direction }: Props) => {
  return (
    <Button
      onClick={()=> callback(direction)}
      variant="outlined" 
      size="small"
      style={{
        borderRadius: 999,
        backgroundColor: "#000",
        color: "#d1d0cf",
        borderColor: "#d1d0cf",
        padding: "1px 1px",
        fontFamily: "Inter",
        fontSize: "12px",
        display: "inline"
      }}
      >
      {label}
    </Button>
  )
}

export default PageButton